/* eslint-disable */
import axios from 'axios'
import envUrl from '../../baseUrl'
import { CODE_OK } from 'utils/publicData.js'
import { getToken, setToken, removeToken } from 'utils/auth.js'
import { Toast, Loading } from 'vant';
import {browserEnvironment, linkApp, isWeixin } from 'utils/index'
import store from '../store/store'
const wx = require('weixin-js-sdk');

import qs from 'qs'
/**
 * 定义请求常量
 * TIME_OUT、ERR_OK
 */
export const TIME_OUT = 1800000;    // 请求超时时间
export let baseUrl = envUrl.Protocol;   // 引入全局url，定义在全局变量process.env中，开发环境为了方便转发，值为空字符串
// console.log(envUrl)
// 请求超时时间
axios.defaults.timeout = TIME_OUT;
axios.defaults.baseURL = baseUrl;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';

// if(getToken()){
//   axios.defaults.headers.common["token"] = getToken();
// }
//setToken("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoie1wibWVtYmVySWRcIjoxMTcyMTYsXCJ0eXBlXCI6MixcIklwXCI6XCIxNzIuMjEuMTc3LjIwNlwiLFwiQWdlbmN5SWRcIjowfSIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvZXhwaXJhdGlvbiI6IjExLzE1LzIwMjMgODowNToyOCBQTSIsIm5iZiI6MTcwMDAxMzkyOCwiZXhwIjoxNzAwMDQ5OTI4LCJpc3MiOiJnc3ciLCJhdWQiOiJnc3cifQ.mK4kFgifFNzrZlWW-xLU05SRyuOw8cp37Zxptq2Mjl0")
// setToken("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoie1wibWVtYmVySWRcIjoxMTc1MDcsXCJ0eXBlXCI6MixcIklwXCI6XCIxNzIuMjEuMTc3LjIwNlwiLFwiQWdlbmN5SWRcIjowfSIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvZXhwaXJhdGlvbiI6IjExLzE0LzIwMjMgODoxODowMCBQTSIsIm5iZiI6MTY5OTkyODI4MCwiZXhwIjoxNjk5OTY0MjgwLCJpc3MiOiJnc3ciLCJhdWQiOiJnc3cifQ.k7s_5JfOeG3wrfmURgWC23n_J5ddF9zeAt9y4IDCCaA")
  // setToken("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoie1wibWVtYmVySWRcIjo0MTE4NixcInR5cGVcIjoyLFwiSXBcIjpcIjE3Mi4xOC4xNjUuODJcIixcIkFnZW5jeUlkXCI6MTkxMX0iLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2V4cGlyYXRpb24iOiI0LzgvMjAyMyA1OjIzOjA4IEFNIiwibmJmIjoxNjgwODY2NTg4LCJleHAiOjE2ODA5MDI1ODgsImlzcyI6ImdzdyIsImF1ZCI6ImdzdyJ9.WWVS-yXzwQk43VVPMUDfdsmBKAzc7Blc8CsqWTHV4eQ")
// setToken("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoie1wibWVtYmVySWRcIjozNjg0OTQsXCJ0eXBlXCI6MixcIklwXCI6XCIxNzIuMTguMTY1LjgyXCIsXCJBZ2VuY3lJZFwiOjgwMDF9IiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9leHBpcmF0aW9uIjoiNC84LzIwMjMgMjo0OTowOCBBTSIsIm5iZiI6MTY4MDg1NzM0OCwiZXhwIjoxNjgwODkzMzQ4LCJpc3MiOiJnc3ciLCJhdWQiOiJnc3cifQ.jTFg5W8G_RAyXABrE6h-sULNGnL22kzwsZ5kXQqBbn4")
// setToken("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoie1wibWVtYmVySWRcIjoxMTcyMTYsXCJ0eXBlXCI6MixcIklwXCI6XCIxNzIuMjEuMTc3LjIwNlwiLFwiQWdlbmN5SWRcIjowfSIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvZXhwaXJhdGlvbiI6IjMvMTcvMjAyMyA5OjU0OjM2IFBNIiwibmJmIjoxNjc5MDI1Mjc2LCJleHAiOjE2NzkwNjEyNzYsImlzcyI6ImdzdyIsImF1ZCI6ImdzdyJ9.oUcgnkld0BiNWqyxeypLpWyzsIXBuKWZsnorhR8RaQI")
// setToken("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoie1wibWVtYmVySWRcIjo5NCxcInR5cGVcIjoyLFwiSXBcIjpcIjE3Mi4yNC4zMi4xMDdcIixcIkFnZW5jeUlkXCI6MX0iLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2V4cGlyYXRpb24iOiI4LzIvMjAyNCAzOjIyOjIxIEFNIiwibmJmIjoxNzIyNTA0MTQxLCJleHAiOjE3MjI1NDAxNDEsImlzcyI6ImdzdyIsImF1ZCI6ImdzdyJ9.kDBgrb-vUOMJV93tiSAnwibbAELmw60A2xGTea7ph_c")
axios.defaults.headers.common["token"] = getToken();
// axios.defaults.withCredentials = true;
// 封装请求拦截
axios.interceptors.request.use(
  config => {
    // if (config.method === 'post') {
    //   config.data = qs.stringify(config.data)
    // }
    store.commit('showLoading');
    console.log("getToken：" + getToken());
    if (getToken() != 'undefined' && getToken() != undefined) {
      config.headers['Authorization'] = getToken()
      // console.log("apiconfig");
      // console.log("getToken:" + getToken());
    }
    // console.log(getToken());
    if (config.method === 'post') {
      console.log("config");
      console.log(config);
      if(config.url.indexOf("dashscope.aliyuncs.com") > -1){ // 阿里百炼
        config.baseURL = config.url;
        var key = "sk-1b456f34f9b445dabab3edaaa1230e73";
        config.headers['Content-Type'] = 'application/json';
        config.headers['Authorization'] = `Bearer ${key}`;



      }else{
        config.baseURL = envUrl.Protocol.replace("{param}", config.data.service);
        // config.headers.common['token'] = getToken();
        config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        // config.headers['Platform'] = 'WXSAAS';
        config.headers['Platform'] = 'XKEJ';
        config.data = {
          global: {
            ip: '',
            os: 4,
            sign: '',
            // token: getToken(),
            timestamp: 0,
            version: '',
            imei: '',
            memberID: '',
          },
          ...config.data
        }
      }

    } else {
      config.baseURL = envUrl.Protocol.replace("{param}", config.data.service);
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
      config.headers['Platform'] = 'XKEJ';
      config.params = {
        ...config.params
      }
    }
    // if (config.method === 'post' && config.flag) {
    //   return config
    // }else if (config.method === 'post') {
    //   config.data = qs.stringify(config.data)
    // }
    return config
  },
  error => {
    store.commit('hideLoading')
    return Promise.reject(error)
  }
)
// 封装响应拦截，判断token是否过期
axios.interceptors.response.use(
  response => {
    store.commit('hideLoading')
    Toast.clear();
    console.log("response");
    console.log(JSON.stringify(response));
    let { data } = response;
    if(response.config && (response.config.url.indexOf('dashscope.aliyuncs.com') > -1) && (response.status == 200)){ // 阿里百炼
      return Promise.resolve(response)
    }else{
      if (data.basis.status === 310) {    // 如果后台返回的错误标识为token过期，则重新登录
        console.log("310")
        let options = {
          token: getToken(),
          appletHasToken: () => {
            console.log("appletHasToken")
            let xcxUrl = '/pages/login/login'
            wx.miniProgram.redirectTo({ url: xcxUrl })
          },
          appletNoToken: () => {
            let xcxUrl = '/pages/login/login'
            wx.miniProgram.redirectTo({ url: xcxUrl })
          },
          weiXinHasToken: () => {
          },
          weiXinNoToken: () => {
          },
          iphoneHasToken: () => {
            console.log("iphoneHasToken--310")
            let appParams = {
              pageType: 'gologin'
            }
            linkApp(appParams, '', appParams.pageType)
          },
          iphoneNoToken: () => {
            console.log("iphoneNoToken--310")
            let appParams = {
              pageType: 'gologin'
            }
            linkApp(appParams, '', appParams.pageType)
          },
          androidHasToken: () => {
            console.log("androidHasToken--310")
            let appParams = {
              pageType: 'gologin'
            }
            linkApp(appParams, '', appParams.pageType)
          },
          androidNoToken: () => {
            console.log("androidNoToken--310")
            let appParams = {
              pageType: 'gologin'
            }
            linkApp(appParams, '', appParams.pageType)
          },
          browserHasToken: () => {
          },
          browserNoToken: () => {
          }
        };
        browserEnvironment(options)
        // removeToken();
      } else if(data.basis.status === 300){
        Toast.fail(data.basis.msg);
      }else  {
        return Promise.resolve(response)
      }
    }

  },
  error => {
    console.log("error", error);
    store.commit('hideLoading')
    return Promise.reject(error)
  }
)
// 封装post请求
export default axios
